// extracted by mini-css-extract-plugin
export var bounce = "_np-1";
export var generatingText = "_np-6";
export var lightning = "_np-4";
export var popup = "_np-5";
export var progressBar = "_np-7";
export var progressFill = "_np-8";
export var progressShimmer = "_np-9";
export var progressText = "_np-a";
export var shimmer = "_np-3";
export var uploadIcon = "_np-0";
export var uploadingText = "_np-2";